<template>
    <v-dialog v-model="open" persistent max-width="600" scrollable>
        <v-card>
            <v-toolbar :elevation="0" color="primary" dark>
                <v-toolbar-title>Medidores</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-3" style="max-height: 70vh">
                <v-card v-for="meter in meters" :key="meter.id" outlined class="mb-3">
                    <v-list-item>
                        <v-list-item-avatar :color="status[meter.id].color">
                            <v-icon color="white">mdi-resistor</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content >
                            <v-list-item-title>
                                {{ meter.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-caption">
                                {{ meter.id }} - {{ meter.type === 'generation' ? 'Generación': 'Consumo' }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="d-flex">
                            <v-menu absolute offset-y v-if="status[meter.id].data" style="max-height: 300px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on"  small>
                                        <v-icon>mdi-list-box-outline</v-icon>
                                    </v-btn>
                                </template>
                                <v-card class="d-flex" height="300px">
                                    <v-card-text class="text-caption pa-0 overflow-auto">
                                        <v-list dense class="pa-0">
                                            <div class="text-center py-2">
                                                {{ status[meter.id].data.updated.toLocaleString() }}
                                            </div>
                                            <v-divider></v-divider>
                                            <template v-for="prop in Object.keys(status[meter.id].data)">
                                                <v-list-item dense :key="prop" v-if="prop !== 'updated'">
                                                    <v-list-item-content class="font-weight-bold">
                                                        {{ prop }}:
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        {{ parseFloat(status[meter.id].data[prop]).toFixed(2) }}
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-list-item-action>
                        <v-list-item-action>
                             <v-btn icon small @click="editMeter(meter.id)">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row class="text-center" v-if="status[meter.id].data">
                            <v-col>
                                <p class="my-0 font-weight-bold">{{parseFloat(status[meter.id].data.netKwh).toFixed(2)}}</p>
                                <p class="my-0 text-caption">Net Kwh</p>
                            </v-col>
                            <v-col>
                                <p class="my-0 font-weight-bold">{{parseFloat(status[meter.id].data.totalPower).toFixed(2)}}</p>
                                <p class="my-0 text-caption">Total Power</p>
                            </v-col>
                            <v-col>
                                <p class="my-0 font-weight-bold">{{parseFloat(status[meter.id].data.totalCurrent).toFixed(2)}}</p>
                                <p class="my-0 text-caption">Total Current</p>
                            </v-col>
                        </v-row>
                        <div v-else class="text-center">
                            No data
                        </div>
                    </v-card-text>
                </v-card>
                <v-card outlined color="grey lighten-3" @click="addMeter">
                    <v-card-text class="text-center py-3">
                        <p class="my-0">
                            <v-icon>mdi-plus</v-icon>
                        </p>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>

        <MeterForm
            :open="meterForm.open"
            :meter_id="meterForm.id"
            :gateway_id="gateway_id"
            @close="closeMeterForm"
        />
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import MeterForm from '../formMeters.vue'
export default {
    name: 'MetersDialog',
    props: ['open', 'gateway_id', 'meters', 'lastReadings'],
    components: { MeterForm },
    computed:{
        ...mapState({
            minutesToWarn: state => state.account.profile.minutesToWarn,
            minutesToDanger: state => state.account.profile.minutesToDanger
        }),
        status(){
            const status = {}
            this.meters.forEach( meter => {
                const base = { data: null , color: 'blue-grey darken-1' }
                if(!this.lastReadings) return status[meter.id] = base

                const read = this.lastReadings.find( read => read.meter === meter.id)
                if(!read) return status[meter.id] = base

                base.data = read.data
                const time = base.data.updated.getTime()
                const diff = (new Date().getTime() - time) / (1000 * 60)
                
                if(diff > this.minutesToDanger) base.color = 'red darken-3'
                else if(diff > this.minutesToWarn) base.color = 'yellow accent-4'
                else base.color = 'accent'

                status[meter.id] = base
            });
            return status
        }
    },
    data() {
        return {
            meterForm: {
                id: null,
                open: false
            }
        }
    },
    methods: {
        addMeter(){
            this.meterForm.open = true
        },
        editMeter(meter){
            this.meterForm.id = meter
            this.meterForm.open = true
        },
        closeMeterForm(){
            this.meterForm.id = null
            this.meterForm.open = false
        },
        close(){
            this.$emit('close')
        },
    },
}
</script>
